__turbopack_context__.v({
  "actionableTitle": "DiagnosticWizard-module__6Sgu-a__actionableTitle",
  "aiInfoItem": "DiagnosticWizard-module__6Sgu-a__aiInfoItem",
  "aiInfoLabel": "DiagnosticWizard-module__6Sgu-a__aiInfoLabel",
  "aiInfoValue": "DiagnosticWizard-module__6Sgu-a__aiInfoValue",
  "aiResilienceDetails": "DiagnosticWizard-module__6Sgu-a__aiResilienceDetails",
  "aiResilienceHeader": "DiagnosticWizard-module__6Sgu-a__aiResilienceHeader",
  "aiResilienceIcon": "DiagnosticWizard-module__6Sgu-a__aiResilienceIcon",
  "aiResilienceInfo": "DiagnosticWizard-module__6Sgu-a__aiResilienceInfo",
  "aiResilienceLabel": "DiagnosticWizard-module__6Sgu-a__aiResilienceLabel",
  "aiResilienceScore": "DiagnosticWizard-module__6Sgu-a__aiResilienceScore",
  "aiResilienceSection": "DiagnosticWizard-module__6Sgu-a__aiResilienceSection",
  "aiTools": "DiagnosticWizard-module__6Sgu-a__aiTools",
  "alignmentType": "DiagnosticWizard-module__6Sgu-a__alignmentType",
  "backButton": "DiagnosticWizard-module__6Sgu-a__backButton",
  "badge": "DiagnosticWizard-module__6Sgu-a__badge",
  "badgeAI": "DiagnosticWizard-module__6Sgu-a__badgeAI",
  "badgeScore": "DiagnosticWizard-module__6Sgu-a__badgeScore",
  "bar": "DiagnosticWizard-module__6Sgu-a__bar",
  "barFill": "DiagnosticWizard-module__6Sgu-a__barFill",
  "blurredCard": "DiagnosticWizard-module__6Sgu-a__blurredCard",
  "card": "DiagnosticWizard-module__6Sgu-a__card",
  "competitionHigh": "DiagnosticWizard-module__6Sgu-a__competitionHigh",
  "competitionLevel": "DiagnosticWizard-module__6Sgu-a__competitionLevel",
  "competitionLow": "DiagnosticWizard-module__6Sgu-a__competitionLow",
  "competitionMedium": "DiagnosticWizard-module__6Sgu-a__competitionMedium",
  "confidenceBadge": "DiagnosticWizard-module__6Sgu-a__confidenceBadge",
  "container": "DiagnosticWizard-module__6Sgu-a__container",
  "crossSellButton": "DiagnosticWizard-module__6Sgu-a__crossSellButton",
  "crossSellContent": "DiagnosticWizard-module__6Sgu-a__crossSellContent",
  "description": "DiagnosticWizard-module__6Sgu-a__description",
  "employerHint": "DiagnosticWizard-module__6Sgu-a__employerHint",
  "encouragement": "DiagnosticWizard-module__6Sgu-a__encouragement",
  "encouragementInline": "DiagnosticWizard-module__6Sgu-a__encouragementInline",
  "evolutionPath": "DiagnosticWizard-module__6Sgu-a__evolutionPath",
  "exampleSection": "DiagnosticWizard-module__6Sgu-a__exampleSection",
  "exampleText": "DiagnosticWizard-module__6Sgu-a__exampleText",
  "freelanceDetails": "DiagnosticWizard-module__6Sgu-a__freelanceDetails",
  "freelanceHeader": "DiagnosticWizard-module__6Sgu-a__freelanceHeader",
  "freelanceIcon": "DiagnosticWizard-module__6Sgu-a__freelanceIcon",
  "freelanceLabel": "DiagnosticWizard-module__6Sgu-a__freelanceLabel",
  "freelanceScore": "DiagnosticWizard-module__6Sgu-a__freelanceScore",
  "freelanceSection": "DiagnosticWizard-module__6Sgu-a__freelanceSection",
  "freelanceStat": "DiagnosticWizard-module__6Sgu-a__freelanceStat",
  "freelanceStats": "DiagnosticWizard-module__6Sgu-a__freelanceStats",
  "futureProofSkills": "DiagnosticWizard-module__6Sgu-a__futureProofSkills",
  "futureSkillCard": "DiagnosticWizard-module__6Sgu-a__futureSkillCard",
  "futureSkillName": "DiagnosticWizard-module__6Sgu-a__futureSkillName",
  "futureSkillReason": "DiagnosticWizard-module__6Sgu-a__futureSkillReason",
  "geoFinderCrossSell": "DiagnosticWizard-module__6Sgu-a__geoFinderCrossSell",
  "giBillNote": "DiagnosticWizard-module__6Sgu-a__giBillNote",
  "gigPlatforms": "DiagnosticWizard-module__6Sgu-a__gigPlatforms",
  "guidanceBox": "DiagnosticWizard-module__6Sgu-a__guidanceBox",
  "high": "DiagnosticWizard-module__6Sgu-a__high",
  "journeyAge": "DiagnosticWizard-module__6Sgu-a__journeyAge",
  "journeyCard": "DiagnosticWizard-module__6Sgu-a__journeyCard",
  "journeyDescription": "DiagnosticWizard-module__6Sgu-a__journeyDescription",
  "journeyHeader": "DiagnosticWizard-module__6Sgu-a__journeyHeader",
  "journeyOutcome": "DiagnosticWizard-module__6Sgu-a__journeyOutcome",
  "journeyPath": "DiagnosticWizard-module__6Sgu-a__journeyPath",
  "journeySection": "DiagnosticWizard-module__6Sgu-a__journeySection",
  "journeyStep": "DiagnosticWizard-module__6Sgu-a__journeyStep",
  "locationCard": "DiagnosticWizard-module__6Sgu-a__locationCard",
  "locationHeader": "DiagnosticWizard-module__6Sgu-a__locationHeader",
  "locationName": "DiagnosticWizard-module__6Sgu-a__locationName",
  "locationRank": "DiagnosticWizard-module__6Sgu-a__locationRank",
  "locationStat": "DiagnosticWizard-module__6Sgu-a__locationStat",
  "locationStats": "DiagnosticWizard-module__6Sgu-a__locationStats",
  "locationsGrid": "DiagnosticWizard-module__6Sgu-a__locationsGrid",
  "locationsSection": "DiagnosticWizard-module__6Sgu-a__locationsSection",
  "lockIcon": "DiagnosticWizard-module__6Sgu-a__lockIcon",
  "lockedContent": "DiagnosticWizard-module__6Sgu-a__lockedContent",
  "lockedHint": "DiagnosticWizard-module__6Sgu-a__lockedHint",
  "lockedOverlay": "DiagnosticWizard-module__6Sgu-a__lockedOverlay",
  "lockedPreview": "DiagnosticWizard-module__6Sgu-a__lockedPreview",
  "low": "DiagnosticWizard-module__6Sgu-a__low",
  "matchReasons": "DiagnosticWizard-module__6Sgu-a__matchReasons",
  "matchScore": "DiagnosticWizard-module__6Sgu-a__matchScore",
  "medium": "DiagnosticWizard-module__6Sgu-a__medium",
  "moreSteps": "DiagnosticWizard-module__6Sgu-a__moreSteps",
  "navigation": "DiagnosticWizard-module__6Sgu-a__navigation",
  "nextActions": "DiagnosticWizard-module__6Sgu-a__nextActions",
  "nextButton": "DiagnosticWizard-module__6Sgu-a__nextButton",
  "option": "DiagnosticWizard-module__6Sgu-a__option",
  "optionsContainer": "DiagnosticWizard-module__6Sgu-a__optionsContainer",
  "outcomeLabel": "DiagnosticWizard-module__6Sgu-a__outcomeLabel",
  "outcomeRole": "DiagnosticWizard-module__6Sgu-a__outcomeRole",
  "outcomeSalary": "DiagnosticWizard-module__6Sgu-a__outcomeSalary",
  "passionAlignment": "DiagnosticWizard-module__6Sgu-a__passionAlignment",
  "passionHeader": "DiagnosticWizard-module__6Sgu-a__passionHeader",
  "passionIcon": "DiagnosticWizard-module__6Sgu-a__passionIcon",
  "passionLabel": "DiagnosticWizard-module__6Sgu-a__passionLabel",
  "passionTag": "DiagnosticWizard-module__6Sgu-a__passionTag",
  "passionTags": "DiagnosticWizard-module__6Sgu-a__passionTags",
  "pathwayBadges": "DiagnosticWizard-module__6Sgu-a__pathwayBadges",
  "pathwayCard": "DiagnosticWizard-module__6Sgu-a__pathwayCard",
  "pathwayHeader": "DiagnosticWizard-module__6Sgu-a__pathwayHeader",
  "pathwayMeta": "DiagnosticWizard-module__6Sgu-a__pathwayMeta",
  "pathwayMilestones": "DiagnosticWizard-module__6Sgu-a__pathwayMilestones",
  "pathwayStats": "DiagnosticWizard-module__6Sgu-a__pathwayStats",
  "pathwaysCTA": "DiagnosticWizard-module__6Sgu-a__pathwaysCTA",
  "pathwaysSection": "DiagnosticWizard-module__6Sgu-a__pathwaysSection",
  "pathwaysSubtitle": "DiagnosticWizard-module__6Sgu-a__pathwaysSubtitle",
  "pathwaysTitle": "DiagnosticWizard-module__6Sgu-a__pathwaysTitle",
  "platformLink": "DiagnosticWizard-module__6Sgu-a__platformLink",
  "platformName": "DiagnosticWizard-module__6Sgu-a__platformName",
  "platformRate": "DiagnosticWizard-module__6Sgu-a__platformRate",
  "platformsList": "DiagnosticWizard-module__6Sgu-a__platformsList",
  "preheader": "DiagnosticWizard-module__6Sgu-a__preheader",
  "premiumBadge": "DiagnosticWizard-module__6Sgu-a__premiumBadge",
  "premiumButton": "DiagnosticWizard-module__6Sgu-a__premiumButton",
  "premiumTeaser": "DiagnosticWizard-module__6Sgu-a__premiumTeaser",
  "progress": "DiagnosticWizard-module__6Sgu-a__progress",
  "progressBarFill": "DiagnosticWizard-module__6Sgu-a__progressBarFill",
  "progressBarTrack": "DiagnosticWizard-module__6Sgu-a__progressBarTrack",
  "progressInfo": "DiagnosticWizard-module__6Sgu-a__progressInfo",
  "progressText": "DiagnosticWizard-module__6Sgu-a__progressText",
  "progressTime": "DiagnosticWizard-module__6Sgu-a__progressTime",
  "progressWrapper": "DiagnosticWizard-module__6Sgu-a__progressWrapper",
  "projectTag": "DiagnosticWizard-module__6Sgu-a__projectTag",
  "projectTags": "DiagnosticWizard-module__6Sgu-a__projectTags",
  "projectTypes": "DiagnosticWizard-module__6Sgu-a__projectTypes",
  "questionCard": "DiagnosticWizard-module__6Sgu-a__questionCard",
  "questionText": "DiagnosticWizard-module__6Sgu-a__questionText",
  "remoteNote": "DiagnosticWizard-module__6Sgu-a__remoteNote",
  "resilienceFactors": "DiagnosticWizard-module__6Sgu-a__resilienceFactors",
  "restartButton": "DiagnosticWizard-module__6Sgu-a__restartButton",
  "resultContainer": "DiagnosticWizard-module__6Sgu-a__resultContainer",
  "resultSummary": "DiagnosticWizard-module__6Sgu-a__resultSummary",
  "resumeDescription": "DiagnosticWizard-module__6Sgu-a__resumeDescription",
  "resumeSection": "DiagnosticWizard-module__6Sgu-a__resumeSection",
  "resumeUpgrade": "DiagnosticWizard-module__6Sgu-a__resumeUpgrade",
  "salaryLabel": "DiagnosticWizard-module__6Sgu-a__salaryLabel",
  "salaryRange": "DiagnosticWizard-module__6Sgu-a__salaryRange",
  "salarySection": "DiagnosticWizard-module__6Sgu-a__salarySection",
  "scoreBar": "DiagnosticWizard-module__6Sgu-a__scoreBar",
  "scoreBreakdown": "DiagnosticWizard-module__6Sgu-a__scoreBreakdown",
  "scoreCircle": "DiagnosticWizard-module__6Sgu-a__scoreCircle",
  "scoreLabel": "DiagnosticWizard-module__6Sgu-a__scoreLabel",
  "scoreNumber": "DiagnosticWizard-module__6Sgu-a__scoreNumber",
  "section": "DiagnosticWizard-module__6Sgu-a__section",
  "sectionHeader": "DiagnosticWizard-module__6Sgu-a__sectionHeader",
  "sectionIcon": "DiagnosticWizard-module__6Sgu-a__sectionIcon",
  "sectionSubtitle": "DiagnosticWizard-module__6Sgu-a__sectionSubtitle",
  "segmentHeaderNote": "DiagnosticWizard-module__6Sgu-a__segmentHeaderNote",
  "selected": "DiagnosticWizard-module__6Sgu-a__selected",
  "shareStoryButton": "DiagnosticWizard-module__6Sgu-a__shareStoryButton",
  "skillCards": "DiagnosticWizard-module__6Sgu-a__skillCards",
  "skillTag": "DiagnosticWizard-module__6Sgu-a__skillTag",
  "skillTags": "DiagnosticWizard-module__6Sgu-a__skillTags",
  "skipButton": "DiagnosticWizard-module__6Sgu-a__skipButton",
  "specializationItem": "DiagnosticWizard-module__6Sgu-a__specializationItem",
  "specializationsList": "DiagnosticWizard-module__6Sgu-a__specializationsList",
  "starterButton": "DiagnosticWizard-module__6Sgu-a__starterButton",
  "starters": "DiagnosticWizard-module__6Sgu-a__starters",
  "startersSection": "DiagnosticWizard-module__6Sgu-a__startersSection",
  "statItem": "DiagnosticWizard-module__6Sgu-a__statItem",
  "statLabel": "DiagnosticWizard-module__6Sgu-a__statLabel",
  "statValue": "DiagnosticWizard-module__6Sgu-a__statValue",
  "stepAction": "DiagnosticWizard-module__6Sgu-a__stepAction",
  "stepContent": "DiagnosticWizard-module__6Sgu-a__stepContent",
  "stepDuration": "DiagnosticWizard-module__6Sgu-a__stepDuration",
  "stepNumber": "DiagnosticWizard-module__6Sgu-a__stepNumber",
  "stepRole": "DiagnosticWizard-module__6Sgu-a__stepRole",
  "storiesGrid": "DiagnosticWizard-module__6Sgu-a__storiesGrid",
  "storyAvatar": "DiagnosticWizard-module__6Sgu-a__storyAvatar",
  "storyCard": "DiagnosticWizard-module__6Sgu-a__storyCard",
  "storyDetails": "DiagnosticWizard-module__6Sgu-a__storyDetails",
  "storyHeader": "DiagnosticWizard-module__6Sgu-a__storyHeader",
  "storyLocation": "DiagnosticWizard-module__6Sgu-a__storyLocation",
  "storyMeta": "DiagnosticWizard-module__6Sgu-a__storyMeta",
  "storyName": "DiagnosticWizard-module__6Sgu-a__storyName",
  "storyQuote": "DiagnosticWizard-module__6Sgu-a__storyQuote",
  "storySalary": "DiagnosticWizard-module__6Sgu-a__storySalary",
  "storySteps": "DiagnosticWizard-module__6Sgu-a__storySteps",
  "storyTime": "DiagnosticWizard-module__6Sgu-a__storyTime",
  "storyTransition": "DiagnosticWizard-module__6Sgu-a__storyTransition",
  "substepIndicator": "DiagnosticWizard-module__6Sgu-a__substepIndicator",
  "successStoriesSection": "DiagnosticWizard-module__6Sgu-a__successStoriesSection",
  "successStoryCta": "DiagnosticWizard-module__6Sgu-a__successStoryCta",
  "successStoryHeader": "DiagnosticWizard-module__6Sgu-a__successStoryHeader",
  "successStoryIcon": "DiagnosticWizard-module__6Sgu-a__successStoryIcon",
  "textarea": "DiagnosticWizard-module__6Sgu-a__textarea",
  "title": "DiagnosticWizard-module__6Sgu-a__title",
  "toolDifficulty": "DiagnosticWizard-module__6Sgu-a__toolDifficulty",
  "toolItem": "DiagnosticWizard-module__6Sgu-a__toolItem",
  "toolName": "DiagnosticWizard-module__6Sgu-a__toolName",
  "toolsList": "DiagnosticWizard-module__6Sgu-a__toolsList",
  "unlockButton": "DiagnosticWizard-module__6Sgu-a__unlockButton",
  "upgradeButton": "DiagnosticWizard-module__6Sgu-a__upgradeButton",
  "verifiedBadge": "DiagnosticWizard-module__6Sgu-a__verifiedBadge",
  "veryhigh": "DiagnosticWizard-module__6Sgu-a__veryhigh",
  "verylow": "DiagnosticWizard-module__6Sgu-a__verylow",
});
